import { useEffect, useState } from "react";
import { Crown } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Toggle } from "./ProfileFieldPrimitives";

// Privacy → "Show my VIP badge" switch. Tier keeps computing server-side; only visibility changes.
export default function VipBadgeVisibilityRow() {
  const [me, setMe] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/vip/me").then(({ data }) => setMe(data)).catch(() => setMe({}));
  }, []);

  const toggle = async (show) => {
    setBusy(true);
    try {
      const { data } = await api.put("/vip/me/badge", { hidden: !show });
      setMe((m) => ({ ...(m || {}), badge_hidden: data.badge_hidden }));
      toast.success(data.badge_hidden ? "VIP badge hidden from your profile, posts and Live chat." : "VIP badge is showing again.");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't update badge visibility.");
    } finally {
      setBusy(false);
    }
  };

  const hint = me?.label ? `You're ${me.label} this month` : "Applies whenever you earn a monthly VIP tier";
  return (
    <div className="flex items-center justify-between px-4 py-3.5 gap-3" data-testid="profile-privacy-vip-badge-row">
      <div className="min-w-0">
        <div className="text-[15px] text-white flex items-center gap-2"><Crown size={14} className="text-amber-300" /> Show my VIP badge</div>
        <div className="text-[11px] text-zinc-500 mt-0.5 leading-tight" data-testid="profile-privacy-vip-badge-hint">{hint}</div>
      </div>
      <div className={busy || !me ? "opacity-50 pointer-events-none" : ""}>
        <Toggle checked={!me?.badge_hidden} onChange={toggle} testId="profile-privacy-vip-badge-toggle" />
      </div>
    </div>
  );
}
